import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from '../services';
import { LangCode } from '../models';

@Pipe({
  name: 'sgmtranslate',
  pure: false // Ensures it updates when language changes
})
export class SgmTranslatePipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(translations: { lang_code?: LangCode; langCode?: LangCode; language?: LangCode }[], key: string): string {
    if (!translations || !key) return '';

    // Access the change counter to make the pipe reactive to language changes
    this.languageService.getChangeCounter();

    const currentLang = this.languageService.currentLanguage;

    let translation = translations.find((t) => t.lang_code === currentLang);
    if (translations.find((t) => t.langCode === currentLang)) {
      translation = translations.find((t) => t.langCode === currentLang);
    } else if (translations.find((t) => t.language === currentLang)) {
      translation = translations.find((t) => t.language === currentLang);
    }
    return translation ? translation[key] : '';
  }
}
